/**
 * useClipTrimming
 */
import { useMemo } from 'react';

import { useMediaConfigReel } from 'bdvp-common/src/hooks/config';

const useClipTrimming = (mediaPlayback = {}) => {

    const config = useMediaConfigReel();
    const { creation = {} } = config;
    const segments = useMemo(() => {

        const playbacks = mediaPlayback.feeds?.[0]?.playbacks ?? [];
        const { creation = {} } = config;
        const supportedPlaybackScenarios = creation.supportedPlaybackScenarios ?? [
            'hlsCloud',
            'HTTP_CLOUD_WIRED_60',
            'HTTP_CLOUD_WIRED_WEB',
            'HTTP_CLOUD_TABLET_60',
            'HTTP_CLOUD_TABLET',
            'HTTP_CLOUD_MOBILE',
        ];

        let highPriorityPlayback = {};

        if (playbacks.length > 0) {

            supportedPlaybackScenarios.some((supportedPlaybackScenario) => {

                const filteredPlayback = playbacks.filter((playback) => {

                    return playback.name === supportedPlaybackScenario;

                })[0];

                if (filteredPlayback) {

                    highPriorityPlayback = filteredPlayback;
                    return true;

                }

                return false;

            });

        }

        let segments = highPriorityPlayback.segments ?? [];

        if (segments.length > 0) {

            segments = [
                0,
                ...segments,
            ];

        }

        return segments;

    }, [
        mediaPlayback,
        config,
    ]);

    return {
        segments,
        canTrim: segments.length >= (creation.minSegments ?? 1),
    };

};

export default useClipTrimming;
